import { useCallback, useEffect, useRef, useState } from 'react';

import http from 'src/services/httpService';
import errorHandler from 'src/utils/error-handler';

function useBowTieData(riscoId, saved) {
  const latestRequest = useRef(0);
  const [values, setValues] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const reload = useCallback(async () => {
    const requestId = latestRequest.current + 1;
    latestRequest.current = requestId;

    if (!riscoId) {
      setValues(null);
      setIsLoading(false);
      return;
    }

    try {
      setIsLoading(true);

      const response = await http.post('/Risco/ObterBowTie', { riscoId });

      if (requestId === latestRequest.current) {
        setValues(response.data || null);
      }
    } catch (err) {
      if (requestId === latestRequest.current) {
        setValues(null);
        errorHandler(err);
      }
    } finally {
      if (requestId === latestRequest.current) {
        setIsLoading(false);
      }
    }
  }, [riscoId]);

  useEffect(() => {
    reload();
  }, [reload, saved]);

  useEffect(
    () => () => {
      latestRequest.current += 1;
    },
    []
  );

  return { values, isLoading, reload };
}

export default useBowTieData;
